import { IconSvgProps } from '../types';

export const PartyPopper = ({ size }: IconSvgProps) => (
  <svg
    id="icon-object-party popper"
    width={size}
    height={size}
    viewBox="0 0 65 65"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="currentColor">
        <g transform="translate(37.000000, 0.000000)">
          <g opacity="0.5">
            <path d="M8.38,12.3 C8.67,12.4 9,12.4 9.29,12.3 L16.05,9.7 C17.13,9.2 17.13,7.7 16.05,7.3 L9.29,4.7 C9,4.6 8.67,4.6 8.38,4.7 L1.62,7.3 C0.54,7.7 0.54,9.2 1.62,9.7 L8.38,12.3 Z" />
            <path d="M7.66,15.7 C8.07,16.8 9.6,16.8 10.02,15.7 L12.62,8.9 C12.73,8.6 12.73,8.3 12.62,8 L10.02,1.3 C9.6,0.2 8.07,0.2 7.66,1.3 L5.05,8 C4.94,8.3 4.94,8.6 5.05,8.9 L7.66,15.7 Z" />
          </g>
          <path
            d="M24.95,21.4 C24.95,19.3 23.25,17.6 21.16,17.6 C19.06,17.6 17.37,19.3 17.37,21.4 C17.37,23.5 19.06,25.2 21.16,25.2 C23.25,25.2 24.95,23.5 24.95,21.4 Z"
            fillRule="nonzero"
          />
          <path
            d="M27.47,4.4 C27.47,2.3 25.78,0.6 23.68,0.6 C21.59,0.6 19.89,2.3 19.89,4.4 C19.89,6.5 21.59,8.2 23.68,8.2 C25.78,8.2 27.47,6.5 27.47,4.4 Z"
            fillRule="nonzero"
            opacity="0.5"
          />
        </g>
        <g transform="translate(0.000000, 3.000000)" fillRule="nonzero">
          <polygon points="14.39 16.6 10.16 29.6 31.64 51.1 44.32 46.5" />
          <polygon points="3.96 48.7 8.18 35.7 25.73 53.2 13.05 57.7" />
          <path d="M1.98,54.7 L0.6,59 C0.47,59.4 0.48,59.8 0.62,60.2 C0.97,61.2 2.06,61.7 3.04,61.3 L7.14,59.9 L1.98,54.7 Z" />
          <path d="M50.23,44.4 L58.68,41.4 C59.24,41.2 59.74,40.8 60.15,40.4 C61.59,38.9 61.53,36.5 60.01,35 L24.92,1.7 C24.51,1.3 24.02,1 23.48,0.9 C21.49,0.2 19.36,1.3 18.71,3.3 L16.36,10.5 L50.23,44.4 Z" />
        </g>
        <g
          opacity="0.5"
          transform="translate(1.000000, 12.000000)"
          fillRule="nonzero"
        >
          <polygon points="15.86 0 15.36 1.5 49.23 35.4 43.32 37.5 13.39 7.6 12.45 10.5" />
          <polygon points="2.96 39.7 0.98 45.7 6.14 50.9 12.05 48.7" />
          <polygon points="24.73 44.2 7.18 26.7 5.73 31.1 9.14 20.6 30.59 42.1" />
        </g>
      </g>
    </g>
  </svg>
);
